module.exports = __webpack_public_path__ + "static/media/Tropical.9aa4c6f2.jpg";